import { EmptyState, PageHeader } from '@portals-platform/ui';
import { UsersIcon } from 'lucide-react';
import { PortalShell } from '../components/portal-shell.js';

export function TeamPage() {
  return (
    <PortalShell activeId="team" pageTitle="Team">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader
          title="Team"
          description="Manage team members, roles, and access permissions."
        />
        <EmptyState
          icon={<UsersIcon />}
          title="Team management coming soon"
          description="Invite users, assign roles, and manage workspace access controls will appear here."
        />
      </div>
    </PortalShell>
  );
}
